module.exports = __webpack_public_path__ + "static/media/sq4.48de935c.jpg";